import kk from './kk';
import ru from './ru';
import en from './en';

const messages: Record<string, { translation: Record<string, any> }> = {
  kk: { translation: kk },
  ru: { translation: ru },
  en: { translation: en },
};

export default messages;